import { render } from "./Race.vue?vue&type=template&id=592c4363"
import script from "./Race.vue?vue&type=script&lang=js"
export * from "./Race.vue?vue&type=script&lang=js"
script.render = render

export default script